module.exports = __webpack_public_path__ + "bdb95e437d57d060b37583e708e9a401.svg";